/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCaseCategoryDTO interface.
 */
export function instanceOfWarehouseCaseCategoryDTO(value) {
    return true;
}
export function WarehouseCaseCategoryDTOFromJSON(json) {
    return WarehouseCaseCategoryDTOFromJSONTyped(json, false);
}
export function WarehouseCaseCategoryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'subjectRequired': json['subjectRequired'] == null ? undefined : json['subjectRequired'],
        'allowsFreeReference': json['allowsFreeReference'] == null ? undefined : json['allowsFreeReference'],
        'allowedSubjectTypes': json['allowedSubjectTypes'] == null ? undefined : json['allowedSubjectTypes'],
    };
}
export function WarehouseCaseCategoryDTOToJSON(json) {
    return WarehouseCaseCategoryDTOToJSONTyped(json, false);
}
export function WarehouseCaseCategoryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'subjectRequired': value['subjectRequired'],
        'allowsFreeReference': value['allowsFreeReference'],
        'allowedSubjectTypes': value['allowedSubjectTypes'],
    };
}
